import {getRankValue, levelColors} from 'platform/components';
import {type ThemeColorPath} from 'platform/foundation';

import {getSafely} from 'shared/web';

/** Light surface tint paired with each {@link levelColors} rank entry (same index). */
const photoCheckerRankSurfaceBackgroundColors: ThemeColorPath[] = [
  'palettes.neutral.20.100',
  'palettes.red.10.100',
  'palettes.orange.10.100',
  'palettes.yellow.10.100',
  'palettes.green.10.100',
  'palettes.blue.10.100',
];

const defaultPhotoCheckerRankSurfaceColors = {
  backgroundColor: 'palettes.neutral.20.100',
  borderColor: 'palettes.neutral.40.100',
} as const satisfies {backgroundColor: ThemeColorPath; borderColor: ThemeColorPath};

export function getPhotoCheckerRankSurfaceColors(score: number | null | undefined): {
  backgroundColor: ThemeColorPath;
  borderColor: ThemeColorPath;
} {
  const rank = getRankValue(score ?? null);

  return {
    backgroundColor: getSafely(
      photoCheckerRankSurfaceBackgroundColors,
      rank,
      defaultPhotoCheckerRankSurfaceColors.backgroundColor
    ),
    borderColor: getSafely(levelColors, rank, defaultPhotoCheckerRankSurfaceColors.borderColor),
  };
}
